import * as React from "react"
import { useState } from "react"
import { Link } from "gatsby"
import { Dialog } from "@headlessui/react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faBars, faXmark } from "@fortawesome/free-solid-svg-icons"
import { StaticImage } from "gatsby-plugin-image"
import Button from "./button"

const navigation = [
  { name: "Project Map", href: "/map" },
  { name: "Project List", href: "/project-list" },
  { name: "Cities on the Cusp", href: "/cities/" },
  { name: "Latest Stories", href: "/stories/" },
  { name: "Legislation", href: "/legislation/" },
  { name: "Tools and Resources", href: "/tools/" },
  { name: "FAQ", href: "/faq" },
  { name: "About", href: "/about" },
]

export default function Navigation() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
  return (
    <header className="">
      <nav className="flex justify-between items-center md:items-end py-4 pl-4 pr-2 text-3xl font-dharma font-light">
        <div className="flex items-center">
          <div className="flex items-end space-x-4 mr-5">
            <Link to="/">
              <StaticImage
                src="../assets/logo.png"
                alt="Great Bike Infrastructure Project Logo"
                placeholder="blurred"
                width={280}
                className="mx-auto"
              />
            </Link>
          </div>
        </div>

        <div className="flex items-center">
          <div className="mr-5">
            <Button
              text="Donate"
              link="https://www.classy.org/give/117371/#!/donation/checkout"
              type="default"
              color="yellow"
            />
          </div>
          <button
            type="button"
            className="flex items-center"
            onClick={() => setMobileMenuOpen(true)}
          >
            <span className="uppercase font-montserrat font-bold text-sm mr-3">
              Menu
            </span>
            <FontAwesomeIcon icon={faBars} />
          </button>
        </div>

        {/* <div className="hidden lg:flex items-center leading-none">
          {navigation.map(item => (
            <Link
              to={item.href}
              key={item.name}
              className="text-black hover:text-pfb-blue transition px-4"
              activeClassName="text-pfb-blue"
            >
              {item.name}
            </Link>
          ))}
        </div> */}
      </nav>
      <Dialog as="div" open={mobileMenuOpen} onClose={setMobileMenuOpen}>
        <div className="fixed inset-0 z-10" />
        <Dialog.Panel className="fixed inset-y-0 right-0 z-10 w-full overflow-y-auto bg-pfb-navy px-6 py-6 sm:max-w-sm sm:ring-1 sm:ring-gray-900/10">
          <div className="mt-8">
            <button
              type="button"
              className="text-white absolute top-0 right-0 p-4 text-2xl"
              onClick={() => setMobileMenuOpen(false)}
            >
              <span className="sr-only">Close menu</span>
              <FontAwesomeIcon icon={faXmark} />
            </button>
            <div className="flex flex-col">
              {navigation.map(item => (
                <Link
                  to={item.href}
                  key={item.name}
                  className="text-white hover:no-underline underline underline-offset-2 py-3 text-3xl font-dharma font-light"
                >
                  {item.name}
                </Link>
              ))}
            </div>
            <div className="mt-4">
              <Button
                text="Donate"
                link="https://www.classy.org/give/117371/#!/donation/checkout"
                type="default"
                color="yellow"
              />
            </div>
          </div>
        </Dialog.Panel>
      </Dialog>
    </header>
  )
}
